<template>
  <div v-if="data">
    <h1 class="mb-4">{{ data.title }}</h1>
    <mdb-container fluid class="bg-white py-3">
      <VueShowdown :markdown=data.text />
    </mdb-container>
    <mdb-card v-if="data.docs_uzLat" class="my-5">
      <mdb-card-header color="bg-light text-dark">O'zbek tilidagi (lotincha) sug'urta shartnomalar</mdb-card-header>
      <ul class="list-group">
        <li class="list-group-item" :key="item.id" v-for="item in data.docs_uzLat">
          <download-link :uri="item.directus_files_id.id" :name="item.directus_files_id.title" />
        </li>
      </ul>
    </mdb-card>
    <mdb-card v-if="data.docs_uzCyrillic" class="my-5">
      <mdb-card-header color="bg-light text-dark">Ўзбек тилидаги (кириллица) суғурта шартномалар</mdb-card-header>
      <ul class="list-group">
        <li class="list-group-item" :key="item.id" v-for="item in data.docs_uzCyrillic">
          <download-link :uri="item.directus_files_id.id" :name="item.directus_files_id.title" />
        </li>
      </ul>
    </mdb-card>
    <mdb-card v-if="data.docs_ru" class="my-5">
      <mdb-card-header color="bg-light text-dark">Договора страхования на русском языке</mdb-card-header>
      <ul class="list-group">
        <li class="list-group-item" :key="item.id" v-for="item in data.docs_ru">
          <download-link :uri="item.directus_files_id.id" :name="item.directus_files_id.title" />
        </li>
      </ul>
    </mdb-card>
  </div>
</template>

<script>

    import axios from 'axios';
    import {
        mdbContainer,
        mdbCard,
        mdbCardHeader,
    } from "mdbvue";
    import store from "../../store";
    import DownloadLink from "../link/DownloadLink.vue";

    export default {
        name: "takaful",
        components: {
          DownloadLink,
          mdbContainer,
          mdbCard,
          mdbCardHeader,
        },
        data() {
            return {
                data: null,
                pageTitle: null,
                base: process.env.VUE_APP_CONTENT_URL
            }
        },
        watch: {
            $route() {
              this.getTakaful()
            }
        },
        mounted() {
            this.getTakaful()
        },
        methods: {
          getTakaful: function (){
            axios.get(process.env.VUE_APP_CONTENT_2_URL + '/items/takaful/?fields=*.*.*&access_token=' + process.env.VUE_APP_CONTENT_2_REST_TOKEN, {headers:{Authorization: ''}})
                .then(response => {
                  this.data = response.data.data
                  store.commit('setBreadcrumbs',['Исламское страхование']);
                });
          }
        }
    }
</script>

<style scoped>

</style>